let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aoQ1d")).then(() => parcelRequire('4V6BS'));